(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/prescript.js');
'use strict';

svs.accountservicesReact = svs.accountservicesReact || {};
svs.accountservicesReact.gameLimitDepositsForm = svs.accountservicesReact.gameLimitDepositsForm || {};
svs.accountservicesReact.gameLimitDepositsForm.service = svs.accountservicesReact.gameLimitDepositsForm.service || {};
svs.accountservicesReact.gameLimitDepositsForm.dialogs = svs.accountservicesReact.gameLimitDepositsForm.dialogs || {};

svs.accountservicesReact.logger = new svs.core.log.Logger('component:game-limits-deposit-form');


 })(window);